// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".participants-title[data-v-131f0ab7]{font-weight:600;font-size:24px;line-height:28px;letter-spacing:-.5px;color:var(-v--accent-base)}.circle-number[data-v-131f0ab7]{border:1px solid #0067af;border-radius:50%;height:32px;width:32px;line-height:31px;font-size:18px;font-weight:500;max-width:32px;letter-spacing:.15px;color:#0067af;text-align:center;margin-right:12px}", ""]);
// Exports
module.exports = exports;
